import i18n from '@/i18n'
import de from '@/i18n/locales/templates.de.json'

// AD-256: template packages carry English labels; the editor shows them in the user's
// language from one dictionary for every template and release. Unknown text stays as written.
const TEMPLATE_TEXT = { de }

const TEXT_KEYS = [
  'label', 'title', 'description', 'help', 'placeholder', 'itemLabel', 'heading',
  'addLabel', 'deleteLabel', 'deleteConfirm', 'elementsTitle', 'highlightLabel', 'showLabel', 'hideLabel', 'reorderHint',
]

// Fields whose option names stay as the template writes them (AD-256: Simon keeps the shape
// names in English).
const ENGLISH_OPTIONS = new Set(['data.style.surface.edge'])

export function templateText(text) {
  if (typeof text !== 'string') return text
  const dictionary = TEMPLATE_TEXT[i18n.resolvedLanguage || i18n.language]
  return dictionary?.[text.trim()] || text
}

// A copy of a template schema with its user-facing texts in the user's language. Values,
// paths and conditions stay untouched, so configuration and validation do not change.
export function localizeSchema(schema) {
  if (!TEMPLATE_TEXT[i18n.resolvedLanguage || i18n.language]) return schema
  const localize = (node, english = false) => {
    if (Array.isArray(node)) return node.map((entry) => localize(entry, english))
    if (!node || typeof node !== 'object') return node
    const copy = {}
    for (const [key, value] of Object.entries(node)) {
      if (TEXT_KEYS.includes(key) && typeof value === 'string') {
        copy[key] = english ? value : templateText(value)
      } else {
        copy[key] = localize(value, english || (key === 'options' && ENGLISH_OPTIONS.has(node.path)))
      }
    }
    return copy
  }
  return localize(schema)
}
